import { render, staticRenderFns } from "./u-gnb-underline.vue?vue&type=template&id=32b36ff3&scoped=true&"
import script from "./u-gnb-underline.vue?vue&type=script&lang=js&"
export * from "./u-gnb-underline.vue?vue&type=script&lang=js&"
import style0 from "./u-gnb-underline.vue?vue&type=style&index=0&id=32b36ff3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b36ff3",
  null
  
)

export default component.exports